import angular from 'angular';
import uiRouter from '@uirouter/angularjs';
import { input, output } from '@b2b/types/core';
import { CartOrderForm } from '@b2b/types/cart';
import { Membership } from '@b2b/types/membership';
import { CartService, CartServiceModule } from '@b2b/common/services';
import { CartFormsService, CartFormsServiceModule, CartOrderFormWithRequired } from './services/cart-forms.service';
import { isFormRequired } from './utils/form-filters.utils';
import { CartFormsModalFilloutComponentModule } from './modals/fillout/cart-forms-modals-fillout';
import { FormResponseRecord } from './types';


class CartFormsController {
  static $inject = ['CartFormsService', 'CartService'];

  forms = input<CartOrderForm[]>();
  memberships = input<Membership[]>();
  hasError = input<boolean>();
  filteredForms: CartOrderFormWithRequired[] = [];
  respondedFormIds = new Set<string>();
  saveToCart = input<boolean>(true);

  onResponseChange = output<{ form: CartOrderFormWithRequired; response: FormResponseRecord }>();

  constructor(
    private cartFormsService: CartFormsService,
    private cartService: CartService,
  ) {
    // noop
  }

  $onInit() {
    this.saveToCart = this.saveToCart ?? true;
    this.updateFilteredForms();
    this.refreshRespondedFormIds();
  }

  $onChanges(_changes: angular.IOnChangesObject) {
    this.updateFilteredForms();
  }

  private updateFilteredForms() {
    const forms = (this.forms || []) as (CartOrderFormWithRequired)[];
    this.filteredForms = forms.map((form) => ({
      ...form,
      isRequired: isFormRequired(form, form.itemType === 'event' ? 'insideSales' : 'insideSalesIndividual'),
    }));
  }

  refreshRespondedFormIds() {
    const responses = this.cartFormsService.getFormResponses();
    this.respondedFormIds = new Set(responses.map((r) => r.formUUID));
  }

  hasResponded(form: CartOrderFormWithRequired) {
    this.refreshRespondedFormIds();
    return this.respondedFormIds.has(form.uuid ?? '');
  }

  fillOutForm(form: CartOrderFormWithRequired) {
    this.cartFormsService.openFormFilloutModal(form).result.then((response: FormResponseRecord) => {
      this.refreshRespondedFormIds();
      
      if (this.saveToCart) {
        this.cartService.setFormResponseId({ formId: response.formId, formResponseId: response.id });
        this.cartService.updateCart();
      } else {
        this.onResponseChange({ $event: { form: form, response } });
      }
    }).catch(() => {
      // modal dismissed — no action needed
    });
  }
}

export const CartFormsComponentModule = angular
  .module('acme.view.application.cart.components.cart-forms', [
    uiRouter,
    CartServiceModule,
    CartFormsServiceModule,
    CartFormsModalFilloutComponentModule
  ])
  .component('acmeCartForms', {
    templateUrl: 'views/application/views/cart/components/cart-forms/cart-forms.component.tpl.html',
    controller: CartFormsController,
    bindings: {
      forms: '<',
      memberships: '<',
      hasError: '<',
      saveToCart: '<',
      onResponseChange: '&',
    },
  })
  .name;